/* eslint-disable import/no-unused-modules */
import Link from 'next/link';
import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { getUser } from '../../helpers/token';
import { figtree, fraunces } from '../Landing/fonts';
import { ArrowIcon, CheckItem, Stamp } from '../Landing/ui';

// There is no /login page — login happens in a dialog, mounted on click.
const LoginButton = dynamic(() => import('../Header/LoginButton'), {
  ssr: false,
});

// Teaser shown where a members-only story fades out — same journal-card
// language as the rest of the article page.
export default function MembersOnly({ hostingUrl, author }) {
  const [user, setUser] = useState(null);
  const [loginOpen, setLoginOpen] = useState(false);

  useEffect(() => {
    setUser(getUser());
  }, []);

  if (user !== undefined && user !== null)
    return <div style={{ height: 500 }} />;

  return (
    <div
      className={`${figtree.className} tw-mx-auto tw-max-w-xl tw-px-4 tw-text-center`}
    >
      <div className="tw-relative tw-rounded-2xl tw-border tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] [border-width:1.5px] tw-bg-[#FFFDF6] dark:tw-bg-[#15231E] tw-p-7 tw-shadow-[0_24px_50px_-30px_rgba(29,45,40,0.4)] sm:tw-p-9">
        <Stamp
          className="tw-absolute -tw-right-2 -tw-top-6 tw-h-16 tw-w-16 tw-rotate-12 tw-text-amber-600/80 dark:tw-text-amber-500/80 sm:-tw-right-4"
          text="TRAVELFEED · MEMBERS · "
        />
        <p className="tw-m-0 tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.28em] tw-text-primary-700 dark:tw-text-primary-300">
          Members only
        </p>
        <p
          className={`${fraunces.className} tw-mb-0 tw-mt-3 tw-text-[1.55rem] tw-font-semibold tw-leading-snug tw-tracking-tight tw-text-[#1D2D28] dark:tw-text-[#EBE6D9]`}
        >
          The rest of this story is for members.
        </p>
        <p className="tw-mb-0 tw-mt-3 tw-text-[15px] tw-leading-relaxed tw-text-[#5F6F69] dark:tw-text-[#93A69E]">
          Join the TravelFeed community to keep reading. You’ll also unlock over
          31,000 travel blogs from real travelers.
        </p>
        <ul className="tw-mx-auto tw-mt-4 tw-flex tw-w-fit tw-list-none tw-flex-col tw-gap-2 tw-p-0 tw-text-left">
          <CheckItem>Read every members-only story</CheckItem>
          <CheckItem>Follow your favorite travel bloggers</CheckItem>
          <CheckItem>Start your own beautiful travel blog</CheckItem>
        </ul>
        <div className="tw-mt-6 tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-4">
          {/* tf-btn: this card renders inside .postcontent, whose legacy
              `a { color: #009688 !important }` would paint teal-on-teal. */}
          <Link
            href="/"
            prefetch={false}
            className="tf-btn tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-primary-600 tw-px-6 tw-py-3 tw-text-[15px] tw-font-semibold tw-text-white tw-no-underline tw-shadow-[0_10px_30px_-10px_rgba(0,137,123,0.7)] tw-transition-all tw-duration-200 hover:-tw-translate-y-0.5 hover:tw-bg-primary-700 hover:tw-text-white"
          >
            Join the community
            <ArrowIcon />
          </Link>
          <button
            type="button"
            onClick={() => setLoginOpen(true)}
            className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-text-[14px] tw-font-semibold tw-text-primary-700 dark:tw-text-primary-300 hover:tw-underline"
            style={{ fontFamily: 'inherit' }}
          >
            Already a member? Log in
          </button>
          {loginOpen && (
            <LoginButton
              hideButtons
              loginOpen
              onClickClose={() => setLoginOpen(false)}
            />
          )}
        </div>
        {hostingUrl && (
          <p className="tw-mb-0 tw-mt-5 tw-font-mono tw-text-[10px] tw-tracking-wide tw-text-[#8A958F]">
            Originally published on{' '}
            <a
              href={hostingUrl}
              rel="noopener noreferrer"
              target="_blank"
              className="tw-text-primary-700 dark:tw-text-primary-300"
            >
              {!author.displayName || author.displayName === author.username
                ? `@${author.username}`
                : `${author.displayName} @${author.username}`}
              &apos;s travel blog
            </a>
          </p>
        )}
      </div>
    </div>
  );
}
